var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"paySuccess"},[_c('img',{staticStyle:{"width":"240px","display":"inline-block"},attrs:{"src":require("../../../images/order/success.png"),"alt":""}}),_c('div',{staticClass:"payText"},[_vm._v("支付成功 !")]),_c('button',{staticClass:"returnBack",on:{"click":_vm.returnBack}},[_vm._v("返回")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }